import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { COLORS } from '../../../../../constants/CatTripColors';
import { calculateProgress } from '../../../../../constants/CalculateProgress';
import ProgressBar from './ProgressBar';
import styles from './PackSizeTable.module.css';

const PackSizeTable = ({ tripTypeColor, packSizeTableData, accentTextColor }) => {
  const { t } = useTranslation(i18next.language);

  return (
    <div className={styles.tableWrapper}>
      <div className={styles.header} style={{ backgroundColor: tripTypeColor, color: accentTextColor }}>
        {t('tripTypesPageTemplate.basketCategoryStats.packSizeTable.title')}
      </div>
      <div className={styles.content}>
        <div className={styles.label}>{t('tripTypesPageTemplate.basketCategoryStats.packSizeTable.label')}</div>
        {packSizeTableData.map((size) => (
          <div key={size.name} className={styles.row}>
            <div className={styles.statsProgBarWrap}>
              <div className={styles.catStatWrapper}>
                <div className={styles.name}>{size.name}</div>
                <div className={styles.stats}>
                  <div className={styles.percentage}>{size.percentage}%</div>
                  <div className={styles.index} style={{ backgroundColor: COLORS[size.tagColor] }}>
                    {size.index}
                  </div>
                </div>
              </div>
              <ProgressBar progress={calculateProgress(size.percentage)} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

PackSizeTable.propTypes = {
  tripTypeColor: PropTypes.string.isRequired,
  packSizeTableData: PropTypes.array.isRequired,
  accentTextColor: PropTypes.string.isRequired
};

export default PackSizeTable;
